// extracted by mini-css-extract-plugin
module.exports = {"mobileSize":"900","wrapper":"Pagination-module--wrapper--zphYD","prev":"Pagination-module--prev--26QQm","next":"Pagination-module--next--1nxz4"};